import React, { useEffect } from "react";
import { Route, type RouteProps } from "react-router-dom";
import { useAppContext } from "apps/portal/Portal/common/AppContext";

interface Props extends RouteProps {
  documentTitle: string;
}

export const RouteWithDocumentTitle = ({ documentTitle, children, ...rest }: Props) => {
  const { application, currentArenaContent } = useAppContext();
  const currentManagerArenaName = () => currentArenaContent?.name || "Juniper Square";
  const documentTitleSuffix =
    application === "singleManagerPortal" ? currentManagerArenaName() : "Juniper Square";
  const fullDocumentTitle = `${documentTitle} - ${documentTitleSuffix}`;

  useEffect(() => {
    document.title = fullDocumentTitle;
  });

  return <Route {...rest}>{children}</Route>;
};
